export default __webpack_public_path__ + "static/shaneBuying-77856129dfcc2905f9c76f8a715661a4.svg";